import type { PriceVarianceView } from "./types";

const TABS: { view: PriceVarianceView; label: string }[] = [
  { view: "overview", label: "Mehrkosten Top 10" },
  { view: "positions", label: "Alle Mehrkosten" },
  { view: "purchases", label: "Einkaufsvolumen" },
];

/**
 * Reiter der Analyse (Beta-Feedback 2026-10-07). Die Filter stehen darüber
 * und gelten für alle Reiter; ein Wechsel behält sie.
 */
export default function AnalysisTabs({
  active,
  onSelect,
  counts = {},
}: {
  active: PriceVarianceView;
  onSelect: (view: PriceVarianceView) => void;
  counts?: Partial<Record<PriceVarianceView, number | null>>;
}) {
  return (
    <nav aria-label="Analyse" className="mt-5 flex gap-6 overflow-x-auto border-b border-slate-200 text-sm">
      {TABS.map((tab) => {
        const count = counts[tab.view];
        return (
          <button
            key={tab.view}
            type="button"
            aria-current={active === tab.view ? "page" : undefined}
            onClick={() => onSelect(tab.view)}
            className={`-mb-px flex shrink-0 items-center gap-1.5 whitespace-nowrap border-b-2 py-2 font-medium ${active === tab.view ? "border-emerald-600 text-slate-950" : "border-transparent text-slate-600 hover:text-slate-900"}`}
          >
            {tab.label}
            {typeof count === "number" ? (
              <span className="rounded-full bg-slate-100 px-1.5 text-[11px] font-semibold tabular-nums text-slate-700">{count.toLocaleString("de-AT")}</span>
            ) : null}
          </button>
        );
      })}
    </nav>
  );
}
